import fetchTablaApi from "@helper/fetchTablaApi";
import { GsResponse } from "@typings/PageMetaData";
import { useEffect, useState } from "react";

export function useGrapeshotData(urlPath: string) {
  const [gsChannels, setGsChannels] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchGsChannels = async (urlPath: string): Promise<GsResponse> => {
    try {
      const response = await fetchTablaApi<GsResponse>(
        `get-gs-channels?url=${urlPath}`,
        "GET",
      );

      return response;
    } catch (e) {
      return { channels: [], fr: "false" };
    }
  };

  const fetchWithTimeout = async (
    promise: Promise<GsResponse>,
    timeoutMs: number,
  ): Promise<GsResponse> => {
    return Promise.race([
      promise,
      new Promise<GsResponse>((resolve) =>
        setTimeout(() => {
          resolve({ channels: [], fr: "false" });
        }, timeoutMs),
      ),
    ]);
  };

  useEffect(() => {
    const callFetch = async () => {
      if (urlPath === "") {
        setIsLoading(false);
        return;
      }
      const gsData = await fetchWithTimeout(fetchGsChannels(urlPath), 1000); // wait for only 1 sec.
      setGsChannels(gsData.channels);
      setIsLoading(false);
      if (typeof window !== "undefined") {
        window.gsChannels_fr = gsData.fr;
      }
    };

    void callFetch();
  }, [urlPath]);

  return { gsChannels, isLoading };
}
